import InventoryIcon from '@material-ui/icons/ShowChart';
import PosList from '../poscrud/PosList';

const inventory = {
  list: PosList,
  icon: InventoryIcon,
};

export default inventory;